// extracted by mini-css-extract-plugin
export default {"subscription-alert-banner-content":"style_subscription-alert-banner-content__utqHy"};